/* @pareto-engineering/generator-front 1.0.12 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions

const baseClassName = styleNames.base;
const componentClassName = 'person';

/**
 * This is the component description.
 */
const Person = ({
  id,
  className: userClassName,
  style,
  name,
  image,
  role,
  color
  // ...otherProps
}) => {
  const handleImageSrcError = e => {
    e.target.onerror = null;
    e.target.src = '/default-avatar.svg';
  };
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName, `y-${color}`].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("img", {
    className: "image v50 mr-v",
    src: image || '/default-avatar.svg',
    alt: `${name}, ${role}`,
    onError: handleImageSrcError
  }), /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, name && /*#__PURE__*/React.createElement("p", {
    className: "name"
  }, name), role && /*#__PURE__*/React.createElement("p", {
    className: "role"
  }, role)));
};
Person.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The person's image
   */
  image: PropTypes.string.isRequired,
  /**
   *  The person's name
   */
  name: PropTypes.string,
  /**
   *  The person's role
   */
  role: PropTypes.string,
  /**
   * The base color of the person's component
   */
  color: PropTypes.string
};
Person.defaultProps = {
  color: 'background-far'
};
export default Person;